export const SUPPORT_EMAIL = 'support@kynward.com';
export const MAILING_ADDRESS = '5000 Plaza on the Lake Suite 100, Austin, TX 78746 US';

export const CHILD_SAFETY_CONTACT_EMAIL =
  (import.meta.env.VITE_CHILD_SAFETY_CONTACT_EMAIL as string | undefined)?.trim() ||
  'michael.iglesias@elyxoraworks.com';
